import { Badge, Tooltip } from "@mantine/core";

/**
 * Označí dítě z velešínského 5denního tábora, které se zobrazuje uvnitř
 * sedmidenního turnusu. Renderuje se jen pro 5denní děti (child.isFiveDay), jinak nic.
 */
export default function FiveDayBadge({ child }) {
  if (!child?.isFiveDay) {
    return null;
  }

  return (
    <Tooltip
      position="top"
      withArrow
      transition="fade"
      transitionDuration={200}
      label={child.fiveDaySession ?? "5denní tábor"}>
      <Badge size="sm" variant="light" color="indigo" className="ml-1 inline-flex w-fit shrink-0 align-middle">
        5D
      </Badge>
    </Tooltip>
  );
}
